export default "__VITE_ASSET__BZlCz2Ia__"